export class IdTarget {
  value: string

  constructor(value?: string) {
    this.value = value || (Math.random() * 10**8).toString(16);
  }
}
